<template>
  <div class="pb-10">
    <div>
      <v-btn @click="$emit('close')" text color="primary">
        <v-icon>mdi-chevron-left</v-icon>
        กลับ
      </v-btn>
    </div>
    <ValidationObserver ref="observer">
      <div>ชื่อ</div>
      <div>
        <ValidationProvider
          :rules="{
            required: true,
          }"
          name="ชื่อ"
          v-slot="{ errors }"
        >
          <v-text-field
            v-model="input.name"
            :error-messages="errors"
            dense
            outlined
          ></v-text-field>
        </ValidationProvider>
      </div>
      <div>รหัสไปรษณีย์</div>
      <div>
        <ValidationProvider
          :rules="{
            required: true,
          }"
          name="รหัสไปรษณีย์"
          v-slot="{ errors }"
        >
          <ThaiAddressInput
            :inputtype="'number'"
            @select="onSelectAddress"
            v-model="input.postCode"
            :type="'zipcode'"
            :errorMessages="errors"
            :texttype="'number'"
          ></ThaiAddressInput>
        </ValidationProvider>
      </div>
      <div>จังหวัด</div>
      <div>
        <ValidationProvider
          :rules="{
            required: true,
          }"
          name="จังหวัด"
          v-slot="{ errors }"
        >
          <v-text-field
            :error-messages="errors"
            v-model="input.province"
            dense
            outlined
          ></v-text-field>
        </ValidationProvider>
      </div>
      <div>อำเภอ/เขต</div>
      <div>
        <ValidationProvider
          :rules="{
            required: true,
          }"
          name="อำเภอ/เขต"
          v-slot="{ errors }"
        >
          <v-text-field
            :error-messages="errors"
            v-model="input.district"
            dense
            outlined
          ></v-text-field>
        </ValidationProvider>
      </div>
      <div>ตำบล/แขวง</div>
      <div>
        <ValidationProvider
          :rules="{
            required: true,
          }"
          name="ตำบล/แขวง"
          v-slot="{ errors }"
        >
          <v-text-field
            :error-messages="errors"
            v-model="input.subDistrict"
            dense
            outlined
          ></v-text-field>
        </ValidationProvider>
      </div>
      <div>ที่อยู่จัดส่ง (บ้านเลขที่ / ซอย / ถนน)</div>
      <div>
        <ValidationProvider
          :rules="{
            required: true,
          }"
          name="ที่อยู่จัดส่ง"
          v-slot="{ errors }"
        >
          <v-textarea
            :error-messages="errors"
            v-model="input.address"
            row="2"
            dense
            outlined
          ></v-textarea>
        </ValidationProvider>
      </div>
      <div>เบอร์โทรศัพท์</div>
      <div>
        <ValidationProvider
          :rules="{
            required: true,
          }"
          name="เบอร์โทรศัพท์"
          v-slot="{ errors }"
        >
          <v-text-field
            :error-messages="errors"
            v-model="input.phoneNumber"
            dense
            outlined
          ></v-text-field>
        </ValidationProvider>
      </div>
    </ValidationObserver>
    <div>
      <v-btn
        @click="saveAddress"
        color="primary"
        :loading="saveloading"
        style="font-size: 19px"
        block
        >{{ type == "create" ? "เพิ่มที่อยู่" : "แก้ไขที่อยู่" }}</v-btn
      >
    </div>
  </div>
</template>

<script>
import ThaiAddressInput from "@/components/ThaiAddressInput.vue";
export default {
  components: {
    ThaiAddressInput,
  },
  props: {
    type: {
      type: String,
      default: "",
    },
    dataedit: {
      default: "",
    },
  },
  data() {
    return {
      saveloading: false,
      input: {
        name: "",
        postCode: "",
        province: "",
        district: "",
        subDistrict: "",
        phoneNumber: "",
        address: "",
        default: false,
      },
    };
  },
  mounted() {
    if (this.type == "edit" && this.dataedit) {
      Object.assign(this.input, this.dataedit);
    }
  },
  methods: {
    async saveAddress() {
      if (await this.$refs.observer.validate()) {
        if (this.type == "create") {
          this.$emit("oncreate", this.input);
          this.$emit("close");
        } else {
          this.$emit("onedit", this.input);
          this.$emit("close");
        }
      }
      //   this.isEdit = false;
    },
    onSelectAddress(address) {
      this.input.district = address.amphoe;
      this.input.province = address.province;
      this.input.subDistrict = address.district;
      this.input.postCode = address.zipcode;
    },
  },
};
</script>

<style lang="scss" scoped></style>
